module.exports = __webpack_public_path__ + "static/media/shopping-trolley_1f6d2.b2db35a4.png";